export type InstitutionType = {
  institutionUuid: string;
  institutionRtId: string;
  institutionEnvironment: string;
  consumerNameProduct: string;
  isDefault: boolean;
  businessUnitId: string;
  createDateTime: string;
  createdBy: string;
  updateDateTime: string;
  updatedBy: string;
  eTag?: string;
};

export type InstitutionListResponse = {
  messageStatus: string | null;
  institutions: InstitutionType[];
  pageKey: string;
  totalCount: number;
};

function parseBooleanField(val: unknown): boolean {
  if (val === true || val === "true") return true;
  if (val === false || val === "false") return false;
  return Boolean(val);
}

/**
 * Normalize a single institution row from API response, handling PascalCase
 * field names that the Business Unit Service may return alongside camelCase.
 */
export function normalizeInstitution(row: Record<string, unknown>): InstitutionType {
  if (row == null) {
    return {
      institutionUuid: "", institutionRtId: "", institutionEnvironment: "",
      consumerNameProduct: "", isDefault: false, businessUnitId: "",
      createDateTime: "", createdBy: "", updateDateTime: "", updatedBy: "", eTag: "",
    };
  }
  return {
    institutionUuid: (row.institutionUuid ?? row.InstitutionUuid ?? "") as string,
    institutionRtId: (row.institutionRtId ?? row.InstitutionRtId ?? "") as string,
    institutionEnvironment: (row.institutionEnvironment ?? row.InstitutionEnvironment ?? "") as string,
    consumerNameProduct: (row.consumerNameProduct ?? row.ConsumerNameProduct ?? "") as string,
    isDefault: parseBooleanField(row.isDefault ?? row.IsDefault ?? false),
    businessUnitId: (row.businessUnitId ?? row.BusinessUnitId ?? "") as string,
    createDateTime: (row.createDateTime ?? row.CreateDateTime ?? "") as string,
    createdBy: (row.createdBy ?? row.CreatedBy ?? "") as string,
    updateDateTime: (row.updateDateTime ?? row.UpdateDateTime ?? "") as string,
    updatedBy: (row.updatedBy ?? row.UpdatedBy ?? "") as string,
    eTag: (row.eTag ?? row.ETag ?? "") as string,
  };
}
